import React, { ChangeEvent, useEffect, useState } from "react";
import Button from "../../components/Button/Button";
// import InputBox from "../../components/Input/Input";
import Dropdown from "../../components/Dropdown/Dropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuthService from "../../auth/AuthService";
import {
  GetListingData,
  GetInternalIDByPublicID,
  IsAlreadyAddedEmail,
  AddEmailForNotify,
} from "../../services/listing.service";
import { Follow, Unfollow } from "../../services/following.service";
//import { AddToCart } from "../../services/cart.service";
import { handleMessage } from "../../utils/handleMessagePopup";
import { StripeCheckoutForm } from "../../components/Stripe/StripeCheckoutForm/StripeCheckoutForm";
import { handleDate, handleDateWithTime } from "../../utils/formatdate";
import PrivateChat from "../../components/ChatList/PrivateChat";
import { UserNameModal } from "../../components/Modal/UserNameModal/UserNameModal";
import { CheckUserName } from "../../services/username.service";
import AuctionModal from "../../components/Modal/AuctionModal/AuctionModal";
import { EmailModal } from "../../components/Modal/EmailModal/EmailModal";
import { UpdateCheckoutSession } from "../../services/cart.service";
import PayoutModal from "../../components/Modal/PayoutModal/PayoutModal";
import NullPageComponent from "../../components/Tile/NullPageComponent";
import { GetStripeConnectAccountDetails, UpdatePopupShow } from "../../services/stripeConnect.service";
interface LocationState {
  id: string; // or number, depending on your data
}
const MyListing: React.FC<{
  public_id: string;
}> = ({ public_id }) => {
  const { isAuthenticated, getToken, getUser, login } = useAuthService();
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();
  const locationState = location.state as LocationState | null;

  const [state, setState] = useState({
    isCheckoutModal: false,
    isDetailsOpen: window.innerWidth >= 768 ? "block" : "none",
    isDropdownOpen: false,
    isInfoModalOpen: false,
    isUserNameModal: false,
    isProcessing: false,
    ShowCheck: false,
    isLoading: false,
    isButtonLoading: false,
    isAuctionModal: false,
    isEmailModal: false,
    isFollowed: false,
    isProcess: false,
    timeRemaining: { days: "0", hours: "0", minutes: "0", seconds: "0" }, // For the countdown
    isPayoutModal: false,

    name: "",
    birth_name: "",
    buy_now_value: 0,
    date_available: "",
    annualized_value: 0,
    public_bio: "",
    rank: 0,
    tags: "",
    entity_id: "",
    isModerator: false,
    is_static: false,
    is_notify: false,
    user_profile_url: "",
    date_of_birth: "",
    fan_id: "",
    public_id: "",
    follow_status: "",
    status: "",
    membership_status: "",
    fan_username: "",
    loggedIn_id: "",
    messageId: "",
    min_bid_price: 0,
    client_secret: "",
    category: "",
    inputEmail: "",
    error: "",

    socket: null as WebSocket | null,
    chatHistory: [] as any[],
    message: "",
    is_setPayout: true,

    stripeConnectData: {
      stripe_connect_id: "",
      is_charges_enabled: false,
      is_payouts_enabled: false,
      is_popup_show: false
    },
    showNullPage: true,
  });

  const targetDate = new Date(state.date_available).getTime();
  const today = new Date();

  const updateStateFromResponse = (response: any) => {
    if (response.error === null) {
      const storedMessageId = localStorage.getItem("messageId");
      setState((prev) => ({
        ...prev,
        name: response.data.name,
        birth_name: response.data.birthname,
        buy_now_value: response.data.buy_now_price,
        date_available:
          response.data.username === "No username available"
            ? today
            : response.data.date_available,
        annualized_value: response.data.annualized_value,
        public_bio: response.data.bio,
        rank:
          response.data.username === "No username available"
            ? "N/A"
            : response.data.rank,
        tags: response.data.tags ? response.data.tags.join(", ") : "",
        entity_id: response.data.id,
        isModerator: response.data.is_moderator,
        is_static: response.data.is_static,
        loggedIn_id: response.data.loggedIn_id ? response.data.loggedIn_id : "",
        user_profile_url: response.data.image_url,
        follow_status: response.data.follow_status,
        isFollowed: response.data.follow_status === "following" ? true : false,
        date_of_birth: response.data.date_of_birth,
        status: response.data.status,
        membership_status: response.data.membership_status,
        fan_username: response.data.fan_username,
        chatHistory: [],
        category: response.data.category,
        fan_id:
          response.data.username === "No username available"
            ? "N/A"
            : response.data.fan_id,
        public_id: response.data.public_id,
        min_bid_price: response.data.min_bid_price,
        messageId: storedMessageId ? storedMessageId : "",
      }));
      localStorage.removeItem("messageId");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        toggleState("isLoading");

        let finalInternalId = locationState?.id || null;

        if (!finalInternalId && public_id) {
          const result = await GetInternalIDByPublicID(public_id);
          finalInternalId = result.data.internal_id;
        }

        if (finalInternalId) {
          const response = isAuthenticated
            ? await GetListingData(finalInternalId, getToken)
            : await GetListingData(finalInternalId);

          updateStateFromResponse(response);

          if (
            isAuthenticated &&
            (response.data.status === "unclaimed" ||
              response.data.status === "delisted")
          ) {
            const result = await IsAlreadyAddedEmail({
              entity_id: response.data.id,
              email: user?.email,
            });
            setState((pre) => ({ ...pre, is_notify: result.data.exists }));
          }
        }
      } catch (error) {
        console.error("An error occurred while fetching data", error);
      } finally {
        toggleState("isLoading");
      }
    };

    if (public_id) {
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, public_id]);

  useEffect(() => {
    const fetchData = async () => {
      await UpdateCheckoutSession({ entity_id: state.entity_id }, getToken);
    };
    !state.isCheckoutModal &&
      (state.status === "yoinkable" || state.status === "available") &&
      fetchData();
    //eslint-disable-next-line
  }, [state.isCheckoutModal, state.status]);

  useEffect(() => {
    // Update the timer every second
    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      // If the countdown is over, stop the timer
      if (distance <= 0) {
        clearInterval(intervalId);
        setState((prev) => ({
          ...prev,
          timeRemaining: { days: "0", hours: "0", minutes: "0", seconds: "0" },
        }));
      } else {
        // Calculate days, hours, minutes, and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setState((prev) => ({
          ...prev,
          timeRemaining: {
            days:
              days < 10 ? days?.toString().padStart(2, "0") : days.toString(),
            hours:
              hours < 10
                ? hours?.toString().padStart(2, "0")
                : hours.toString(),
            minutes:
              minutes < 10
                ? minutes?.toString().padStart(2, "0")
                : minutes.toString(),
            seconds:
              seconds < 10
                ? seconds?.toString().padStart(2, "0")
                : seconds.toString(),
          },
        }));
      }
    }, 1000); // Update every second
    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [targetDate, state.messageId]);

  // const handleAddToCart = async () => {
  //   try {
  //     if (isAuthenticated) {
  //       const response = await AddToCart(state.user_id, getToken);
  //       if (response.error == null) {
  //         handleMessage("Item added to cart successfully!");
  //         toggleState("isDropdownOpen");
  //         setState((prev) => ({ ...prev, cart_status: "Added" }));
  //       }
  //     } else {
  //       handleMessage("Please Login to Add this Celebrity to Cart!");
  //     }
  //   } catch {
  //     console.error("Unable to add to cart");
  //   }
  // };

  const getButtonLabel = () => {
    if (state.status === "available") {
      return <>Buy Now for ${state.buy_now_value.toLocaleString("en-US")}</>;
    } else if (state.status === "unavailable") {
      return "Unavailable";
    } else if (state.status === "yoinkable") {
      return <>Yoink for ${state.buy_now_value.toLocaleString("en-US")}</>;
    } else if (state.status === "biddable") {
      return "Bid Now";
    } else if (state.status === "unclaimed" || state.status === "delisted") {
      return state.isButtonLoading ? (
        <div className="inside-loader h-100">
          <div className="spinner"></div>
        </div>
      ) : state.follow_status === "following" ? (
        "Unfollow"
      ) : (
        "Follow for Updates"
      );
    } else {
      return "";
    }
  };

  const handleFollow = async () => {
    try {
      toggleState("isButtonLoading");
      const response = await Follow(state.entity_id, getToken);

      if (response.data !== null) {
        // Assuming 'success' indicates the follow action was successful
        setState((prevState) => ({
          ...prevState,
          follow_status: "following", // Update the status
          isFollowed: true,
        }));
      }
    } catch {
      console.error("Unable to follow the user");
    } finally {
      toggleState("isButtonLoading");
    }
  };

  const handleUnfollow = async () => {
    try {
      toggleState("isButtonLoading");
      const response = await Unfollow(state.entity_id, getToken);

      if (response.data !== null) {
        // Assuming 'success' indicates the unfollow action was successful
        setState((prevState) => ({
          ...prevState,
          follow_status: "not_following", // Update the status
          isFollowed: false,
        }));
      }
      toggleState("isButtonLoading");
    } catch {
      toggleState("isButtonLoading");
      console.error("Unable to unfollow the user");
    }
  };

  // Optimized toggle function to handle all boolean state toggles
  const toggleState = (key: keyof typeof state) => {
    setState((prevState) => ({
      ...prevState,
      [key]:
        typeof prevState[key] === "boolean" ? !prevState[key] : prevState[key],
    }));
  };

  // Handle showing/hiding details section
  const toggleDetails = () => {
    setState((prevState) => ({
      ...prevState,
      isDetailsOpen: prevState.isDetailsOpen === "none" ? "block" : "none",
    }));
  };

  const handleBuyProcess = async () => {
    if (state.isProcessing) return;
    toggleState("isProcessing");
    if (isAuthenticated) {
      handleUserNameCheck("isCheckoutModal");
    } else {
      state.status === "unclaimed" || state.status === "delisted"
        ? setState((pre) => ({ ...pre, isEmailModal: true }))
        : login();
    }
    toggleState("isProcessing");
  };

  const handleUserNameCheck = async (val: keyof typeof state) => {
    try {
      const response = await CheckUserName(getToken);
      if (response.data.hasUsername) {
        state.isDropdownOpen && toggleState("isDropdownOpen");
        toggleState(val);
      } else {
        state.isDropdownOpen && toggleState("isDropdownOpen");
        toggleState("isUserNameModal");
      }
    } catch {
      console.error("Unable to check the username");
    }
  };

  const handleUserNameSubmit = async (val: keyof typeof state) => {
    handleMessage("Username saved successfully");
    toggleState("isUserNameModal");
    toggleState(val);
  };

  // const handleEmailModal = async () => {
  //   isAuthenticated ? handleEmailSubmit() : toggleState("isEmailModal");
  // };

  const handleEmailInput = (email: string) => {
    setState((pre) => ({
      ...pre,
      inputEmail: email,
      error: "",
    }));
  };

  const handleEmailSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !isAuthenticated &&
      (state.inputEmail === "" || !emailRegex.test(state.inputEmail))
    ) {
      setState((pre) => ({
        ...pre,
        error: "Please enter a valid email address.",
      }));
      return;
    }

    if (state.error !== "") return;

    try {
      setState((pre) => ({ ...pre, isLoading: !pre.isLoading }));

      const result = await AddEmailForNotify({
        entity_id: state.entity_id,
        email: isAuthenticated ? user?.email : state.inputEmail,
      });

      if (result.error !== null) {
        setState((pre) => ({
          ...pre,
          error:
            result.error.charAt(0).toUpperCase() +
            result.error.slice(1).toLowerCase(),
        }));
        return;
      }

      setState((pre) => ({ ...pre, is_notify: true }));
      handleMessage(result.data.message);
      state.isEmailModal && toggleState("isEmailModal");
    } catch (error) {
      console.error("An error occurred while fetching data", error);
    } finally {
      setState((pre) => ({ ...pre, isLoading: !pre.isLoading }));
    }
  };

  // Function to handle sending a message
  const sendMessageToSocket = () => {
    if (state.socket && state.message) {
      const messageData = {
        sender_id: state.isModerator ? state.entity_id : state.fan_id,
        receiver_id: state.isModerator ? state.fan_id : state.entity_id,
        content: state.message,
      };
      state.socket.send(JSON.stringify(messageData));
      setState((pre) => ({ ...pre, message: "" }));
    }
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setState((pre) => ({ ...pre, message: e.target.value }));
  };

  useEffect(() => {
    if (state.entity_id !== "") {
      const ws = new WebSocket(
        `${process.env.REACT_APP_FAN1_WEBSOCKET_URL}/ws?sender_id=${state.isModerator
          ? state.entity_id
          : state.fan_id !== ""
            ? state.fan_id
            : state.entity_id
        }&receiver_id=${state.isModerator
          ? state.fan_id !== ""
            ? state.fan_id
            : state.entity_id
          : state.entity_id
        }`
      );

      ws.onopen = () => {
        console.log("WebSocket connected");
      };

      ws.onmessage = (event) => {
        const incomingMessage = event.data;

        let messageContent: any;
        let parsedMessage: any;
        try {
          parsedMessage = JSON.parse(incomingMessage);
          messageContent = parsedMessage.content;
        } catch (error) {
          messageContent = incomingMessage;
        }

        if (parsedMessage.sender_id === state.entity_id) {
          setState((prev) => ({
            ...prev,
            chatHistory: [
              ...prev.chatHistory,
              {
                id: prev.chatHistory.length + 1,
                type: "receiving", // Adjust as needed for outgoing messages
                messageID: parsedMessage.id,
                message: messageContent,
                timestamp: handleDateWithTime(parsedMessage.timestamp),
                sender_image_url: parsedMessage.sender_image_url,
                sender_name: parsedMessage.sender_name,
              },
            ],
          }));
        } else {
          setState((prev) => ({
            ...prev,
            chatHistory: [
              ...prev.chatHistory,
              {
                id: prev.chatHistory.length + 1,
                type: "sender", // Adjust as needed for outgoing messages
                messageID: parsedMessage.id,
                message: messageContent,
                timestamp: handleDateWithTime(parsedMessage.timestamp),
                sender_image_url: parsedMessage.sender_image_url,
                sender_name: parsedMessage.sender_name,
              },
            ],
          }));
        }
      };
      setState((prev) => ({ ...prev, socket: ws }));
      return () => {
        ws.close();
      };
    }
  }, [state.fan_id, state.entity_id, state.loggedIn_id, state.isModerator]);

  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      if (isAuthenticated && state.stripeConnectData.stripe_connect_id === "") {
        const res: any = await GetStripeConnectAccountDetails(getToken);
        if (res.data != null && res.error === null) {
          setState((prev) => ({ ...prev, stripeConnectData: res.data}));
        }
      }
    }, 1000);

    return () => clearTimeout(timeoutId);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setState((prev) => ({ ...prev, showNullPage: false }));
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (state.stripeConnectData.stripe_connect_id !== "" &&
        state.stripeConnectData.is_charges_enabled &&
        state.stripeConnectData.is_payouts_enabled &&
        !state.stripeConnectData.is_popup_show && state.showNullPage) {
        await UpdatePopupShow(getToken)
      }
    }

    fetchData();
    //eslint-disable-next-line
  }, [state.stripeConnectData, state.showNullPage])

  return (
    <>
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (
        <></>
      )}
      <div className="container listing-page">
        {isAuthenticated && state.is_setPayout && state.isModerator && (
          <div className="position-relative">
            {state.showNullPage ? (
              <div className="payout-null position-absolute w-100">
                {state.stripeConnectData?.stripe_connect_id !== "" &&
                  state.stripeConnectData?.is_charges_enabled &&
                  state.stripeConnectData?.is_payouts_enabled &&
                  !state.stripeConnectData.is_popup_show ? (
                  <NullPageComponent
                    heading1="Thank you!"
                    heading2="Your payout information has been submitted."
                    heading3="Stripe is verifying your details. If additional information is needed, we will notify you."
                    button1={
                      <Button
                        label="Check your payout status"
                        icon={<i className="fa-regular fa-user ms-2"></i>}
                        className="btn"
                        onClick={() => navigate("/settings/listing")}
                        variant="dark"
                      />
                    }
                  />
                ) : state.stripeConnectData?.stripe_connect_id !== "" &&
                  !state.stripeConnectData?.is_charges_enabled &&
                  !state.stripeConnectData?.is_payouts_enabled ? (
                  <NullPageComponent
                    heading1="Almost There!"
                    heading2="Your payout account needs additional verification."
                    heading3="Please return to Stripe to complete your setup."
                    button1={
                      <Button
                        label="Check your payout status"
                        icon={<i className="fa-regular fa-user ms-2"></i>}
                        className="btn"
                        onClick={() => navigate("/settings/listing")}
                        variant="dark"
                      />
                    }
                  />
                ) : null}
              </div>
            ) : (
              state.stripeConnectData?.stripe_connect_id === "" && (
                <div className="payout-head">
                  <div
                    className="flex text-center space-x-2 px-4 py-1"
                    onClick={() =>
                      setState((pre) => ({ ...pre, isPayoutModal: true }))
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <span className="font-500-15 me-2">
                      Set up payouts to your bank
                    </span>
                    <i className="fa-solid fa-building-columns"></i>
                  </div>
                  <i
                    className="fa-solid fa-xmark cross-icon"
                    onClick={() =>
                      setState((pre) => ({
                        ...pre,
                        is_setPayout: false,
                        isPayoutModal: false,
                      }))
                    }
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
              )
            )}
          </div>
        )}

        <div className="d-flex row mt-4 mx-2">
          <div className="col-lg-6 col my-auto px-0">
            <div className="edit-profile-header">{state.name}</div>
          </div>
          <div className="mobile">
            <div className="fig-data d-flex">
              <div className="fig-img">
                {state.user_profile_url ? (
                  <img
                    src={state.user_profile_url}
                    alt={state.name}
                    className="img-fluid user-image"
                  />
                ) : (
                  <div
                    style={{ borderRadius: "4px 4px 0px 0px" }}
                    className="default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center user-image"
                  >
                    <i className="fa-solid fa-user"></i>
                  </div>
                )}
              </div>
              <div className="fig-img-data">
                <div className="name">{state.name}</div>
                <div className="fan1">
                  Fan1:
                  {state.fan_username === "No username available" ? (<></>
                  ) : (
                    <Link
                      to={{
                        pathname: `/u/${state.fan_username}`,
                      }}
                      className="text-decoration-none purple-color font-inter-300-15"
                    >
                      {" "}
                      @{state.fan_username}
                    </Link>
                  )}
                </div>
              </div>
            </div>
            {!state.isModerator && (
              <div className="buttons">
                <Button
                  className="border-white button"
                  variant="dark"
                  disabled={state.isButtonLoading}
                  label={
                    state.isButtonLoading ? (
                      <div className="inside-loader">
                        <div className="spinner"></div>
                      </div>
                    ) : state.follow_status === "following" ? (
                      "Unfollow"
                    ) : (
                      "Follow"
                    )
                  }
                  onClick={() => {
                    if (isAuthenticated) {
                      state.follow_status === "following"
                        ? handleUnfollow()
                        : handleFollow();
                    } else {
                      handleMessage("Sign in to Follow");
                    }
                  }}
                />
                {state.membership_status === "Owned" ? (
                  <Button
                    label="You are Fan1!"
                    disabled={true}
                    variant="primary"
                    className="py-2 px-4 buy-button mobile-buy-btn"
                  />
                ) : (
                  <Button
                    label={getButtonLabel()}
                    className={`buy-button mobile-buy-btn ${(state.status === "unclaimed" ||
                      state.status === "delisted") &&
                      state.follow_status === "following" &&
                      "disable-btn"
                      }`}
                    onClick={() => {
                      if (
                        state.status === "unclaimed" ||
                        state.status === "delisted"
                      ) {
                        state.follow_status === "following"
                          ? handleUnfollow()
                          : handleFollow();
                      } else if (state.status === "biddable") {
                        if (isAuthenticated) {
                          handleUserNameCheck("isAuctionModal");
                        } else {
                          login();
                        }
                      } else {
                        toggleState("isDropdownOpen");
                      }
                    }}
                  />
                )}
              </div>
            )}
          </div>
          {!state.isModerator && (
            <div className="col-lg-6 col d-flex flex-row-reverse px-0">
              {state.membership_status === "Owned" &&
                state.status !== "biddable" ? (
                <Button
                  label="You are Fan1!"
                  disabled={true}
                  variant="primary"
                  className="py-2 px-4 buy buy-button"
                />
              ) : (
                <Dropdown
                  className={"end-0 my-auto mt-3 dropdown-buymembership"}
                  icon={
                    <Button
                      label={getButtonLabel()}
                      className={`py-2 px-4 buy buy-button ${(state.status === "unclaimed" ||
                        state.status === "delisted") &&
                        state.follow_status === "following" &&
                        "disable-btn"
                        }`}
                      onClick={() => {
                        (state.status === "unclaimed" ||
                          state.status === "delisted") &&
                          (state.follow_status === "following"
                            ? handleUnfollow()
                            : handleFollow());
                        state.status === "biddable" &&
                          (isAuthenticated
                            ? handleUserNameCheck("isAuctionModal")
                            : login());
                      }}
                    />
                  }
                  isOpen={
                    (state.status === "available" ||
                      state.status === "yoinkable") &&
                    state.isDropdownOpen
                  }
                  onToggle={() => toggleState("isDropdownOpen")}
                >
                  <div
                    className="row buy-box my-4 mx-3"
                    style={{ minWidth: "300px" }}
                  >
                    <Button
                      className="col-1 p-1 close-btn"
                      variant="none"
                      label={<i className="fa-solid fa-close"></i>}
                      onClick={() => toggleState("isDropdownOpen")}
                    />
                    <div className="col-12 d-flex justify-content-center heading">
                      Begin Membership
                    </div>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <img
                        src={state.user_profile_url}
                        alt={state.name}
                        style={{
                          width: "40px",
                          height: "45px",
                          borderRadius: "4px",
                        }}
                        className="col-1 p-0"
                      />
                      <div className="py-3 text-start content ms-3">
                        <div className="font-400 font-18">{state.name}</div>
                        <div className="p-0 font-inter-400-14">
                          $ {state.buy_now_value.toLocaleString("en-US")} | 30
                          days
                        </div>
                      </div>
                    </div>
                    <Button
                      type="button"
                      label={
                        <>
                          Go To Checkout{" "}
                          <i className="fa-solid fa-bag-shopping"></i>
                        </>
                      }
                      className="col-12 py-2 buy-button"
                      onClick={handleBuyProcess}
                    />
                    {/* {state.cart_status === "Added" ? (
                    <Button
                      className="border-white col-12 mt-3 py-2 buy-button"
                      variant="dark"
                      label={
                        <>
                          Go to Cart
                          <i className="fa-solid fa-cart-shopping"></i>
                        </>
                      }
                      onClick={() => {
                        toggleState("isDropdownOpen");
                        handleCartOpen(true);
                      }}
                    />
                  ) : (
                    <Button
                      className="border-white col-12 mt-3 py-2 buy-button"
                      variant="dark"
                      label={
                        <>
                          Add to Cart
                          <i className="fa-solid fa-cart-shopping"></i>
                        </>
                      }
                      onClick={handleAddToCart}
                    />
                  )} */}
                  </div>
                </Dropdown>
              )}
              {(state.status === "unavailable" ||
                state.status === "yoinkable" ||
                state.status === "biddable") && (
                  <div
                    className={`countdown my-auto ${state.status === "biddable" && "bid-countdown"
                      }`}
                  >
                    {state.status === "biddable" ? (
                      <div className="heading">
                        {/* <div className="item1">Active Auction</div>
                      <div className="my-auto">Ends In</div>
                      <div className="my-auto">:</div> */}
                        <div className="heading">Auction End</div>
                      </div>
                    ) : (
                      <div className="heading">Next Auction</div>
                    )}
                    <div className="timer font-inter-700-16">
                      <div className="timer-block">
                        {state.timeRemaining.days
                          ? state.timeRemaining.days
                          : "0"}
                        d
                      </div>
                      <div className="timer-block">
                        {state.timeRemaining.hours
                          ? state.timeRemaining.hours
                          : "0"}
                        h
                      </div>
                      <div className="timer-block">
                        {state.timeRemaining.minutes
                          ? state.timeRemaining.minutes
                          : "0"}
                        m
                      </div>
                      <div className="timer-block">
                        {state.timeRemaining.seconds
                          ? state.timeRemaining.seconds
                          : "0"}
                        s
                      </div>
                    </div>
                    <div className="mt-auto">
                      <Dropdown
                        className={"my-auto rounded-3"}
                        icon={<i className="fa-solid fa-circle-info my-auto"></i>}
                        isOpen={state.isInfoModalOpen}
                        onToggle={() => toggleState("isInfoModalOpen")}
                      >
                        <div
                          className="row m-3 buy-box text-white"
                          style={{ minWidth: "300px" }}
                        >
                          <Button
                            className="col-1 p-1 close-btn font-300 font-20"
                            variant="none"
                            label={<i className="fa-solid fa-close"></i>}
                            onClick={() => toggleState("isInfoModalOpen")}
                          />
                          <div className="mb-3 font-500-20">
                            How do auctions work?
                          </div>
                          <div className="font-inter-300-15">
                            Once an auction begins, all users with a verified
                            payment method may place a bid. When the auction ends,
                            the user with the highest bid (and a successful
                            payment) becomes Fan1!
                          </div>
                          <div className="text-center">
                            {/* <div className="font-inter-400-15 text-light-purple my-3">
                            Don’t show this again
                            <div className="d-inline ms-2">
                              <InputBox
                                className="checkbox"
                                type="checkbox"
                                id="ShowCheck"
                                checked={state.ShowCheck}
                                onChange={() => toggleState("ShowCheck")}
                                name="ShowCheck"
                              />
                            </div>
                          </div> */}
                            <Button
                              label={"Follow for updates"}
                              type="button"
                              className="py-2 btn-primary font-500-15 px-4 my-3"
                              onClick={() => {
                                handleFollow();
                                toggleState("isInfoModalOpen");
                              }}
                              disabled={state.isFollowed}
                            />
                          </div>
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>

        <div className="row fig-detail-data mt-3">
          <div className="col-lg col-12 text-start mx-2">
            <div className="profile my-4 text-white text-center pb-0">
              <div className="p-3 pb-2 fig-img">
                {state.user_profile_url ? (
                  <img
                    src={state.user_profile_url}
                    alt={state.name}
                    className="img-fluid user-image"
                  />
                ) : (
                  <div
                    style={{ borderRadius: "4px 4px 0px 0px", height: 250 }}
                    className="text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center user-image"
                  >
                    <i
                      className="fa-solid fa-user"
                      style={{ fontSize: 40 }}
                    ></i>
                  </div>
                )}
              </div>

              <div className="p-4 fig-details text-start">
                {!state.isModerator && (
                  <Button
                    className="border-white col-12 mb-4 button"
                    variant="dark"
                    disabled={state.isButtonLoading}
                    label={
                      state.isButtonLoading ? (
                        <div className="inside-loader">
                          <div className="spinner"></div>
                        </div>
                      ) : state.follow_status === "following" ? (
                        "Unfollow"
                      ) : (
                        "Follow"
                      )
                    }
                    onClick={() => {
                      if (isAuthenticated) {
                        state.follow_status === "following"
                          ? handleUnfollow()
                          : handleFollow();
                      } else {
                        handleMessage("Sign in to Follow");
                      }
                    }}
                  />
                )}

                {state.fan_username === "No username available" &&
                  !state.isModerator ? (
                  <div className="row mb-3 fan1 text-center">
                    <div className="col-12 line-21">
                      <div>
                        <div className="font-500-20 line-24 mb-2">
                          <span>
                            {state.status === "unclaimed" &&
                              "Not available. Click Follow for updates."}
                            {state.status === "delisted" &&
                              "No longer available. Click Follow for updates."}
                            {state.status === "available" &&
                              "Buy now to become Fan1 for 30 days!"}
                            {state.status === "biddable" &&
                              "Bid now to become Fan1 for 30 days!"}
                          </span>
                        </div>
                      </div>
                      {state.status === "available" && (
                        <Button
                          label={
                            state.isProcess
                              ? "Processing..."
                              : `Buy Now for $${state.buy_now_value.toLocaleString(
                                "en-US"
                              )}`
                          }
                          className="py-2 buy buy-button"
                          onClick={() => {
                            if (isAuthenticated) {
                              handleBuyProcess();
                            } else {
                              login();
                            }
                          }}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="row mb-3 fan1 text-center">
                      <div className="col-12 font-inter-500-17 line-21">
                        Fan1
                      </div>
                      <div className="col-12 line-21">
                        {state.fan_username !== "No username available" ? (
                          <Link
                            to={`/u/${state.fan_username}`}
                            className="text-decoration-none purple-color font-inter-300-15"
                          >
                            @{state.fan_username}
                          </Link>
                        ) : (
                          <div className="text-decoration-none purple-color font-inter-300-15">
                            N/A
                          </div>
                        )}

                        {/* {state.username === "No username available" ? (
                          <span className="purple-color font-inter-300-15">
                            No username available
                          </span>
                        ) : (
                          <Link
                            to={{
                              pathname: `/public-fan/${state.fan_id}`,
                            }}
                            className="text-decoration-none purple-color font-inter-300-15"
                          >
                            {" "}
                            @{state.username}
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <div className="font-inter-500-15">Value</div>
                        <div className="font-inter-300-15 extra-light-purple">
                          {(state.annualized_value &&
                            `$${state.annualized_value.toLocaleString(
                              "en-US"
                            )}`) ||
                            "N/A"}
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="font-inter-500-15">Date Available</div>
                        <div className="font-inter-300-15 extra-light-purple">
                          {state.date_available
                            ? handleDate(state.date_available)
                            : "-"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <div className="font-inter-500-15">Buy Now</div>
                        <div className="font-inter-300-15 extra-light-purple">
                          {state.status.toLowerCase() === "unavailable"
                            ? "---"
                            : `$${state.buy_now_value.toLocaleString("en-US")}`}
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="font-inter-500-15">Rank</div>
                        <div className="font-inter-300-15 extra-light-purple">
                          {state.rank ? state.rank : "N/A"}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div
                className="d-flex justify-content-between px-4 py-2 font-inter-400-15"
                style={{
                  borderTopColor: "white",
                  borderTopStyle: "solid",
                  borderTopWidth: 1,
                  cursor: "pointer",
                  transition: "all 0.9s ease",
                }}
                onClick={toggleDetails}
              >
                Details
                <i
                  className={`fa-solid fa-angle-down me-1 mt-1`}
                  style={{
                    transform: `rotate(${state.isDetailsOpen === "none" ? 0 : 180
                      }deg)`,
                    transition: "transform 0.7s ease",
                  }}
                ></i>
              </div>

              <div
                className={`d-${state.isDetailsOpen} me-1 px-4 py-2 text-start`}
                style={{
                  height: state.isDetailsOpen === "none" ? "0" : "auto",
                  overflow: "hidden",
                  transition: "height 0.9s ease",
                }}
              >
                <div className="heading">Bio:</div>
                <div className="mb-2 content">{state.public_bio}</div>
                {state.category === "People" && (
                  <>
                    <div className="heading">Birth Name:</div>
                    <div className="mb-2 content">{state.birth_name}</div>
                    <div className="heading">Date of Birth:</div>
                    <div className="mb-2 content">
                      {state.date_of_birth
                        ? handleDate(state.date_of_birth.split("T")[0])
                        : "-"}
                    </div>
                  </>
                )}
                <div className="heading">Tags:</div>
                <div className="mb-2 content">{state.tags}</div>
                <div className="heading">Fan1 ID:</div>
                <div className="mb-2 content">{state.public_id}</div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12 px-0 my-4">
            <div className="fig-chat">
              <div className="mobile-background-ellipse"></div>
              <div className="mb-0 pt-4 pb-3 text-center heading">
                Message Board
              </div>
              <PrivateChat
                msgID={state.messageId}
                isEntityChat={false}
                figName={state.name}
                chatHistory={state.chatHistory}
                newMessage={state.message}
                onChange={handleChange}
                onSendMessage={sendMessageToSocket}
                msgEnable={
                  isAuthenticated &&
                  (state.fan_id === state.loggedIn_id || state.isModerator)
                }
              />
            </div>
          </div>
          <div className="col-lg px-4 my-4 tile-view col-12 text-white">
            <div className={`image-container mx-auto bg-midnight `}>
              <div className="d-flex flex-column justify-content-center align-items-center align-self-stretch">
                <div className="w-100 d-flex flex-column justify-content-between h-100 data">
                  <div className="d-block">
                    <div className="heading">Be Fan1</div>
                    <p className="content">
                      When you become Fan1, you’re the one and only fan with
                      exclusive access to this membership.
                    </p>
                    <p className="content">
                      Memberships are purchased in one of three ways:
                    </p>
                    <div className="ms-2">
                      <p className="content">
                        • <b>Buy Now</b> - if listed at a set price
                      </p>
                      <p className="content">
                        • <b>Auction</b> - bid for free, only pay if you're the
                        high bidder
                      </p>
                      <p className="content">
                        • <b>Yoink</b> - yes, yoink from the current Fan1 by
                        paying 10x what they paid
                      </p>
                    </div>
                    <p className="content">
                      Your messages, interactions, and membership history stay
                      here after your membership expires. Make your mark and
                      prove your fandom–become Fan1 today!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {state.isCheckoutModal && (
        <StripeCheckoutForm
          isVisible={state.isCheckoutModal}
          itemIds={state.entity_id}
          onClose={() => toggleState("isCheckoutModal")}
          onClick={() => {
            toggleState("isCheckoutModal");
            handleMessage(
              "",
              `<div class='text-white'><div class='font-500-36'>You are now Fan1 to ${state.name}!</div></div>`
            );
          }}
        />
      )}
      {state.isUserNameModal && (
        <UserNameModal
          isVisible={state.isUserNameModal}
          onClose={() => {
            toggleState("isUserNameModal");
          }}
          onClick={() =>
            handleUserNameSubmit(
              state.status !== "biddable" ? "isCheckoutModal" : "isAuctionModal"
            )
          }
          isBuy={
            state.status !== "available" && state.status !== "yoinkable"
              ? false
              : true
          }
        />
      )}

      {state.isAuctionModal && (
        <AuctionModal
          isVisible={state.isAuctionModal}
          onClose={() => {
            toggleState("isAuctionModal");
          }}
          auctionData={{
            id: state.entity_id,
            name: state.name,
            image: state.user_profile_url,
            min_bid_price: state.min_bid_price,
            endtime: state.date_available,
          }}
        />
      )}

      {state.isEmailModal && (
        <EmailModal
          isVisible={state.isEmailModal}
          data={{ error: state.error, email: state.inputEmail }}
          handleEmailInput={handleEmailInput}
          handleSubmit={handleEmailSubmit}
          onClose={() => toggleState("isEmailModal")}
        />
      )}
      {state.isPayoutModal && (
        <PayoutModal
          isVisible={state.isPayoutModal}
          onClose={() => setState((pre) => ({ ...pre, isPayoutModal: false }))}
          onClick={() => { }}
        />
      )}
    </>
  );
};

export default MyListing;
